import { formatInTimeZone } from "date-fns-tz";
import { useEffect, useRef, useState } from "react";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import SweetAlert2 from "react-sweetalert2";
import { ApiStatusTypeEnum } from "../../../enumeration/ApiStatusTypeEnum";
import DateRangeComp from "../../common/DateRangeComp";
import * as actions from "../redux/VipCommissionAction";
import { ProceedDialog } from "./ProceedDialog";
import { VipCommissionEffDialog } from "./VipCommissionEff";

export const VipCommission = ({}) => {
  const [swalProps, setSwalProps] = useState({});
  const [show, setShow] = useState(false);
  const intl = useIntl();
  const dispatch = useDispatch();
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);
  const startOfYesterday = new Date(yesterday.setHours(0, 0, 0, 0));
  const endOfYesterday = new Date(yesterday.setHours(23, 59, 59, 999));
  const [fromDate, setFromDate] = useState(startOfYesterday);
  const [toDate, setToDate] = useState(endOfYesterday);
  const [bearwinlose, setBearwinlose] = useState(true);
  const [queryParams, setQueryParams] = useState();
  const [commnumber, setCommnumber] = useState("");

  const [commissionList, setCommissionList] = useState();
  const timeZone = "Asia/Kuala_Lumpur";
  const queryParamsRef = useRef({});

  useEffect(() => {
    return () => {
      dispatch(actions.clearVipCommissionList());
    };
  }, []);

  const handleDateChange = (start, end) => {
    setFromDate(start);
    setToDate(end);
  };

  const handleSearchClick = () => {
    queryParamsRef.current = {
      action: "membervipcommcalculate",
      fromdate: formatInTimeZone(fromDate, timeZone, "yyyy-MM-dd"),
      todate: formatInTimeZone(toDate, timeZone, "yyyy-MM-dd"),
      commnumber,
      bearwinlose: bearwinlose.toString(),
    };
    dispatch(actions.fetchVipCommissionList(queryParamsRef.current)).then(
      (resp) => {
        resp = resp.data;
        setCommissionList(resp);

        if (parseInt(resp.code) === ApiStatusTypeEnum.COMMON_ERROR) {
          setSwalProps({
            show: true,
            icon: "error",
            title: intl.formatMessage({ id: "error" }),
            text: resp.message,
          });
        }
      }
    );
  };

  return (
    <div style={{ width: "100%", margin: "0 auto" }}>
      <SweetAlert2
        customClass="custom-swal"
        onResolve={() => {
          setSwalProps({});
        }}
        {...swalProps}
      />
      <VipCommissionEffDialog
        setQueryParams={setQueryParams}
        queryParams={queryParams}
        setSwalProps={setSwalProps}
      />
      <ProceedDialog
        setSwalProps={setSwalProps}
        commissionList={commissionList}
        show={show}
        setShow={setShow}
        isClassic={true}
      />
      <div>
        <h2>{intl.formatMessage({ id: "vipCommission" })}</h2>
      </div>
      <div className="d-flex justify-content-between">
        <DateRangeComp
          initialRange={[
            { startDate: fromDate, endDate: toDate, key: "selection" },
          ]}
          onDateChange={handleDateChange}
        />
      </div>
      <div className="my-2">
        {intl.formatMessage({ id: "commission" })}
        <div className="d-flex justify-content-between">
          <div>
            <select className="dropdown respond-Select">
              <option>{intl.formatMessage({ id: "percentage" })}(%)</option>
            </select>
            <input
              type="number"
              className="refund-Input"
              placeholder={intl.formatMessage({ id: "commissionNumber" })}
              value={commnumber}
              onChange={(e) => setCommnumber(e.target.value)}
            />
            <div className="form-check d-inline-block ms-2">
              <input
                className="form-check-input"
                type="checkbox"
                value=""
                id="bearwinlose"
                checked={bearwinlose}
                onChange={(e) => setBearwinlose(e.target.checked)}
              />
              <label className="form-check-label" for="bearwinlose">
                {intl.formatMessage({ id: "bearWinLose" })}
              </label>
            </div>
          </div>

          <div className="d-flex align-items-center">
            <div className="mx-2">
              <button className="btn btn-primary" onClick={handleSearchClick}>
                {intl.formatMessage({ id: "calculate" })}
              </button>
            </div>
            {commissionList?.memberVipCommCalculateLists &&
              commissionList.memberVipCommCalculateLists.length > 0 && (
                <div>
                  <button
                    className="btn btn-success"
                    onClick={() => setShow(true)}
                  >
                    {intl.formatMessage({ id: "publish" })}
                  </button>
                </div>
              )}
          </div>
        </div>
      </div>
      {commissionList && (
        <div
          className={`rounded d-flex align-items-center justify-content-spacebetween py-2 gamelistDiv1 cursor-pointer position-relative text-center mobile-overflow`}
          style={{
            border: "1px solid grey",
            padding: "2px",
            margin: "10px 0 ",
          }}
        >
          <div style={{ width: "100%" }}>
            <table
              className="text-start table-report"
              style={{
                width: "100%",
                minWidth: "1000px",
              }}
            >
              <tbody>
                <tr>
                  <td className="col-6 ps-2 td-line">
                    {intl.formatMessage({ id: "originalRefund" }) +
                      " : " +
                      commissionList?.totalrefund}
                  </td>
                  <td className="col-6 ps-2 ">
                    {intl.formatMessage({ id: "actualRefund" }) +
                      " : " +
                      commissionList?.memberVipCommCalculateLists
                        ?.filter(
                          (memberRefund) =>
                            memberRefund.bonusgain &&
                            !isNaN(parseFloat(memberRefund.bonusgain))
                        )
                        ?.map((memberRefund) =>
                          parseFloat(memberRefund.bonusgain)
                        )
                        ?.reduce((acc, val) => acc + val, 0)
                        ?.toFixed(2) ?? "0.00"}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      )}
      <div
        className="member-div d-flex"
        style={{
          margin: "10px auto",
        }}
      >
        <div className="member-container">
          <div className="table-responsive">
            <table className="member-table">
              <thead className="member-header1">
                <tr className="member-row1">
                  <th className="member-cell hide-on-mobile">
                    {intl.formatMessage({ id: "no" })}
                  </th>
                  <th className="member-cell text-start text-nowrap">
                    {intl.formatMessage({ id: "username" })}
                  </th>
                  <th className="member-cell text-end text-nowrap">
                    {intl.formatMessage({ id: "balance" })}
                  </th>
                  <th className="member-cell text-end text-nowrap">
                    {intl.formatMessage({ id: "gameIn" })}
                  </th>
                  <th className="member-cell text-end text-nowrap">
                    {intl.formatMessage({ id: "gameOut" })}
                  </th>
                  <th className="member-cell text-end text-nowrap">
                    {intl.formatMessage({ id: "winLose" })}
                  </th>
                  <th className="member-cell text-nowrap text-end pe-2">
                    {intl.formatMessage({ id: "refund" })}
                  </th>
                  <th className="member-cell text-nowrap text-start pe-2">
                    {intl.formatMessage({ id: "effCount" })}
                  </th>
                </tr>
              </thead>
              <tbody className="member-body">
                {commissionList?.memberVipCommCalculateLists &&
                commissionList.memberVipCommCalculateLists.length > 0 ? (
                  commissionList.memberVipCommCalculateLists.map(
                    (report, index) => (
                      <tr key={index} className="member-row1">
                        <td className="member-cell hide-on-mobile">
                          {index + 1}
                        </td>
                        <td className="member-cell text-start">
                          {report.username}
                        </td>
                        <td className="member-cell text-end">
                          {report.balanceingame}
                        </td>
                        <td className="member-cell text-end">
                          {report.gamein}
                        </td>
                        <td className="member-cell text-end">
                          {report.gameout}
                        </td>
                        <td className="member-cell text-end">
                          {report.actamount}
                        </td>
                        <td className="member-cell text-end pe-2">
                          <input
                            type="number"
                            className="refund-Input text-end"
                            placeholder="0"
                            value={report.bonusgain}
                            onChange={(e) => {
                              setCommissionList((prev) => {
                                const updatedList = [
                                  ...prev.memberVipCommCalculateLists,
                                ];
                                updatedList[index] = {
                                  ...updatedList[index],
                                  bonusgain: e.target.value,
                                  isedited: "true",
                                };

                                return {
                                  ...prev,
                                  memberVipCommCalculateLists: updatedList,
                                };
                              });
                            }}
                          />
                        </td>
                        <td className="member-cell text-start">
                          <span
                            className={
                              report.effcount !== "0" ? "text-primary" : ""
                            }
                            style={
                              report.effcount !== "0"
                                ? { cursor: "pointer" }
                                : {}
                            }
                            onClick={() => {
                              setQueryParams({
                                action: "membervipcommefflist",
                                memberid: report.memberid,
                                fromdate: queryParamsRef.current.fromdate,
                                todate: queryParamsRef.current.todate,
                                bearwinlose: queryParamsRef.current.bearwinlose,
                              });
                            }}
                          >
                            {report.effcount}
                          </span>
                        </td>
                      </tr>
                    )
                  )
                ) : (
                  <tr>
                    <td colSpan="8">
                      <div className="no-record-wrapper oRecordDiv">
                        <i className="bi bi-search fs-1 mb-3" />
                        <div className="text-font2">
                          {intl.formatMessage({ id: "noRecordFound" })}
                        </div>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};
